import React from 'react';
import { Grid } from '@ui-propulsion/react-components';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import styles from './legalText.module.scss';

export default function LegalText({
  headline = '',
  description = '',
  config = {
    theme: 'white',
    maxWidth: '100%',
    headline: {
      position: 'left',
      fontSize: 'title1',
    },
    description: {
      position: 'left',
      fontSize: 'body',
    },
  },
  theme = 'white',
}) {
  let HeaderTag = config?.headline?.fontSize;
  if (!HeaderTag || !['h1', 'h2', 'h3', 'h4', 'h5', 'p'].includes(HeaderTag)) {
    HeaderTag = 'h2';
  }
  return (
    <div
      className={`${styles.legalText} ${styles[theme]}`}
      style={{
        ...(config.maxWidth && { maxWidth: config.maxWidth }),
      }}
    >
      <Grid container>
        {headline && (
          <Grid item xs={12} sm={12}>
            <HeaderTag
              className={styles.header}
              style={{
                ...(config?.headline?.position && {
                  textAlign: config.headline.position,
                }),
              }}
              data-fontsize={config?.headline?.fontSize ?? 'title1'}
            >
              {parse(headline)}
            </HeaderTag>
          </Grid>
        )}
        <Grid item xs={12} sm={12}>
          {description && (
            <div
              className={styles.content}
              style={{
                ...(config?.content?.position && {
                  textAlign: config.content.position,
                }),
              }}
              data-fontsize={config?.content?.fontSize ?? 'body'}
            >
              {parse(description)}
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

LegalText.propTypes = {
  headline: PropTypes.string,
  description: PropTypes.string,
  config: PropTypes.shape({
    theme: PropTypes.oneOf([
      'white',
      'grey',
      'darkBlue',
      'lightBlue',
      'skyBlue',
    ]),
    maxWidth: PropTypes.string,
    headline: PropTypes.shape({
      position: PropTypes.oneOf(['center', 'left', 'right']),
      fontSize: PropTypes.oneOf([
        'hero',
        'title1',
        'title2',
        'sectionlabel',
        'body',
        'small',
        'micro',
      ]),
    }),
    description: PropTypes.shape({
      position: PropTypes.oneOf(['center', 'left', 'right']),
      fontSize: PropTypes.oneOf([
        'hero',
        'title1',
        'title2',
        'sectionlabel',
        'body',
        'small',
        'micro',
      ]),
    }),
  }),
  theme: PropTypes.string,
};
